import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import Swiper from "swiper";
import Navigation from "swiper/modules/navigation.min.mjs";
import Pagination from "swiper/modules/pagination.min.mjs";
import Thumbs from "swiper/modules/thumbs.min.mjs";

window.Swiper = Swiper;
window.Navigation = Navigation;
window.Pagination = Pagination;
window.Thumbs = Thumbs;

import PhotoSwipe from 'photoswipe/dist/umd/photoswipe.umd.min.js';
import PhotoSwipeLightbox from 'photoswipe/dist/umd/photoswipe-lightbox.umd.min.js';
//import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.min.js';
//import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.min.js';
window.PhotoSwipe = PhotoSwipe;
window.PhotoSwipeLightbox = PhotoSwipeLightbox;


// import { TruckCalculator } from './truck-calculator.es'
// window.TruckCalculator = TruckCalculator;